import type { ComponentProps } from "react";
import { TeacherConsoleScreen } from "../../features/room";

/** FS-11 룸 콘솔(탭: 룸 · 팀 · 스크립트 · 놀이터 · 관찰 · 릴레이 · 영상 · 교류) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/room */
export default function TeacherConsolePage(props: ComponentProps<typeof TeacherConsoleScreen>) {
  return <TeacherConsoleScreen {...props} />;
}
